module.exports = __webpack_public_path__ + "static/media/social_twitter_blue.aba609ad.svg";